import { Box, Flex } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { ParticipantCardHeaderType } from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardHeader/ParticipantCardHeader.type';
import ClientIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/user.svg?react';
import CustomLabel from '@/common/components/base/customLabel/CustomLabel';

const ParticipantCardHeader = ({
  index,
  status,
  isActive,
  damagedType,
}: ParticipantCardHeaderType) => (
  <Flex
    borderBottom="2px dashed {colors.gray-2}"
    justifyContent="space-between"
    py="10px"
    w="90%"
    mx="auto"
  >
    <Flex
      alignItems="center"
      flexDirection={'row'}
      justifyContent="space-between"
      w={'100%'}
    >
      <Box display={'flex'} alignItems={'center'}>
        {index ? (
          <Typography
            textStyle="b4"
            color="black-4"
            pl="15px"
            pr="5px"
            borderLeft="1px solid {colors.gray-2}"
            ml="15px"
          >
            {index}
          </Typography>
        ) : null}
        <ClientIcon />
        {damagedType === 'OTHER' ? (
          <Box mx="10px">
            <CustomLabel title="زیاندیده سایر" color="purpleLight" />
          </Box>
        ) : null}
      </Box>
      <Flex
        alignItems="center"
        flexDirection={'row'}
        justifyItems={'center'}
        gap="5px"
      >
        {isActive ? (
          status?.map((item, index) => (
            <Box key={index} mb="5px">
              <CustomLabel
                title={item.fa_const}
                color={
                  item?.const === 'completed'
                    ? 'green'
                    : item?.const === 'uncompleted'
                      ? 'yellow'
                      : 'black'
                }
              />
            </Box>
          ))
        ) : (
          <Box key={index} mb="5px">
            <CustomLabel title="غیر فعال" color="orange" />
          </Box>
        )}
      </Flex>
    </Flex>
  </Flex>
);
export default ParticipantCardHeader;
